import axios from 'axios'
import store from './store'
import _ from 'lodash'
import * as Cookies from 'js-cookie'

const excludePaths = [
    '/login',
    '/register',
    '/refresh_token',
    '/investments'
]

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use((config) => {
    config.headers = config.headers || {}
    if (!_.includes(excludePaths, config.url)) {
      config.headers.Authorization = store.state.token
      config.headers['Accept-Language'] = store.getters.getLocale
    }
    return config
  }, (err) => {
    return Promise.reject(err)
})

// Interceptor for responses
axios.interceptors.response.use((resp) => {
  return Promise.resolve({status: resp.status, data: resp.data})
}, (err) => {
  if (!err.response) {
    return Promise.reject(err)
  }
  if (401 === err.response.status) {
    //Cookies.remove('vuex')
    store.dispatch('LOGOUT')
  } else {
    return Promise.reject({status: err.response.status, data: err.response.data}) 
  }
})
  